import axios from 'axios'
import { handleHttpErr } from '../apiHelper'

const state = {
    anfragen: [],
    intervalAnfragen: null,
}

const getters = {
    anfragen: state => state.anfragen,
    neueNachrichten: state => state.anfragen.filter(x => x.neueNachrichten).length,
}

const actions = {
    clearAnfragen({ commit }) {
        commit('stopAnfragenInterval')
        commit('updateAnfragen', [])
    },
    async startAnfragenInterval({ commit, dispatch }) {
        commit('startAnfragenInterval', () => dispatch('updateAnfragen'))
    },
    async stopAnfragenInterval({ commit }) {
        commit('stopAnfragenInterval')
    },
    async updateAnfragen({ commit }) {
        try {
            var res = await axios.get("anfragen")
            res.data.sort((b, a) => a.letzteNachricht < b.letzteNachricht ? -1 : a.letzteNachricht > b.letzteNachricht ? 1 : a.id < b.id ? -1 : 1)
            commit('updateAnfragen', res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async verlasseAnfrage({ commit }, anfrage) {
        try {
            await axios.put("anfragen/" + anfrage.id + "/verlassen")
            commit('leaveAnfrage', anfrage.id)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async updateAnfrage({ commit }, anfrage) {
        try {
            var res = await axios.put("anfragen/" + anfrage.id, { includeHandy: !anfrage.includeHandy })
            commit('updateAnfrage', res.data)
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async sendeAnfrage({ commit }, anfrage) {
        try {
            var res = await axios.post("anfragen", anfrage)
            commit('sendeAnfrage', res.data)
            return res.data
        }
        catch (err) {
            throw handleHttpErr(err)
        }
    },
    async leseNachrichten({ commit }, anfrage) {
        if (anfrage.neueNachrichten){
            try {
                var res = await axios.put("nachrichten/" + anfrage.id + "/lesen")
                commit('updateAnfrage', res.data)
            }
            catch (err) {
                throw handleHttpErr(err)
            }
        }
    }
}

const mutations = {
    updateAnfragen: (state, anfragen) => {
        state.anfragen = anfragen
    },
    leaveAnfrage: (state, anfrageId) => {
        var index = state.anfragen.findIndex(x => x.id == anfrageId)
        state.anfragen.splice(index, 1)
    },
    updateAnfrage: (state, anfrage) => {
        var index = state.anfragen.findIndex(x => x.id == anfrage.id)
        if(index == -1)
            return
        state.anfragen.splice(index, 1, anfrage)
        state.anfragen.sort((b, a) => a.letzteNachricht < b.letzteNachricht ? -1 : a.letzteNachricht > b.letzteNachricht ? 1 : a.id < b.id ? -1 : 1)
    },
    sendeAnfrage: (state, anfrage) => {
        state.anfragen.push(anfrage)
        state.anfragen.sort((b, a) => a.letzteNachricht < b.letzteNachricht ? -1 : a.letzteNachricht > b.letzteNachricht ? 1 : a.id < b.id ? -1 : 1)
    },
    startAnfragenInterval: (state, func) => state.intervalAnfragen = setInterval(() => {
        try { 
            func() 
        } catch { 
            clearInterval(state.intervalAnfragen)
            state.intervalAnfragen = null
        }
    }, 10000),
    stopAnfragenInterval: (state) => {
        clearInterval(state.intervalAnfragen)
        state.intervalAnfragen = null
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}